// frontend/src/modules/reports/pages/financial/currencyGroup.ts
//
// Phase 4 (Reports Frontend), Task 4. Every financial report response is
// multi-currency-shaped (a `currency` field per row) and the binding honesty
// rule from the plan is: PER-CURRENCY DATA RENDERS IN PER-CURRENCY SECTIONS,
// NEVER SUMMED ACROSS CURRENCIES. This is the one place that grouping logic
// lives, reused by every financial page.

/** Groups rows by `currency`, sorted by currency code for a stable render order. */
export function groupByCurrency<T extends { currency: string }>(rows: T[]): Array<[string, T[]]> {
  const map = new Map<string, T[]>();
  for (const row of rows) {
    const bucket = map.get(row.currency);
    if (bucket) bucket.push(row);
    else map.set(row.currency, [row]);
  }
  return Array.from(map.entries()).sort(([a], [b]) => a.localeCompare(b));
}
